import { LogoSepa } from './LogoSepa'

export default LogoSepa
